<template>
  <div
    v-if="visible"
    class="tce-wrap"
    role="region"
    aria-label="Continue exploring BarbershopTalk"
  >
    <button
      type="button"
      class="tce-btn"
      @click="onContinue"
    >
      <span class="tce-label">Continue exploring</span>
      <span class="tce-progress">{{ progress.done }} of {{ progress.total }}</span>
    </button>
    <button
      type="button"
      class="tce-dismiss"
      aria-label="Hide Continue exploring for this session"
      @click="onDismiss"
    >
      &times;
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useTutorialProgress } from '@/composables/useTutorialProgress';

export default {
  name: 'TutorialContinueExploring',
  setup() {
    const tutorial = useTutorialProgress();

    const visible = computed(() => tutorial.shouldShowLauncher());
    const progress = computed(() => tutorial.primaryProgress());

    function onContinue() {
      tutorial.continueExploringClicked();
    }

    function onDismiss() {
      tutorial.dismissLauncherSession();
    }

    return {
      visible,
      progress,
      onContinue,
      onDismiss,
    };
  },
};
</script>

<style scoped>
.tce-wrap {
  position: fixed;
  z-index: 3100;
  left: 12px;
  right: 12px;
  bottom: calc(68px + env(safe-area-inset-bottom, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  pointer-events: none;
  font-family: 'Titillium Web', sans-serif;
  text-align: left;
}

.tce-btn {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: min(100%, 360px);
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.92);
  color: #f8fafc;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.28);
  cursor: pointer;
  font-family: inherit;
}

.tce-label {
  font-size: 0.92rem;
  font-weight: 800;
  white-space: nowrap;
}

.tce-progress {
  font-size: 0.8rem;
  font-weight: 700;
  color: #cbd5e1;
  white-space: nowrap;
}

.tce-dismiss {
  pointer-events: auto;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(15, 23, 42, 0.88);
  color: #e2e8f0;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
}

.tce-btn:focus-visible,
.tce-dismiss:focus-visible {
  outline: 3px solid rgba(96, 165, 250, 0.55);
  outline-offset: 2px;
}

@media (min-width: 914px) {
  .tce-wrap {
    left: auto;
    right: 24px;
    bottom: 24px;
    justify-content: flex-end;
  }

  .tce-btn {
    border-radius: 12px;
    background: rgba(15, 23, 42, 0.88);
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
  }
}

@media (max-width: 374px) {
  .tce-label {
    white-space: normal;
  }

  .tce-btn {
    max-width: calc(100% - 48px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .tce-wrap,
  .tce-btn {
    transition: none;
  }
}
</style>
